import React from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { setUpdatePaymentSystem } from '../../store/thunk/setUpdatePaymentSystem';
import { setUpdatePaymentSystemLimit } from '../../store/thunk/setUpdatePaymentSystemLimit';

const PaymentItem = (props) => {
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: {
            isDirty
        },
        watch
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            label: '',
            limit_min: 0,
            limit_max: 0,
            status: false
        }
    })

    React.useEffect(() => {
        reset({
            ...props
        })
    }, [])

    const onSubmit = (store) => {
        dispatch(setUpdatePaymentSystemLimit({
            id:store.id,
            limit_max: store.limit_max,
            limit_min: store.limit_min
        }))
    }

    const label = watch('label');
    const status = watch('status');

    const handleChangeStatus = () => {
        const callbackSuccess = () => {
            setValue('status', !status)
        }
        dispatch(setUpdatePaymentSystem({id: props?.id, status: !props?.status}, callbackSuccess))
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} style={{
            padding: 10,
            background: '#1b2039',
            borderRadius: 10,
            minWidth: 190,
            width: 190,
            display: 'flex',
            flexDirection: 'column',
            rowGap: 10
        }}>
            <div style={{ textAlign: 'center' }}>
                <h4 style={{
                    fontFamily: '-apple-system, sans-serif',
                    color: '#FFFFFF'
                }}>{label}</h4>
            </div>
            <label htmlFor='limit_min' style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: 12,
            }}>
                <span style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    position: 'relative',
                    display: 'inline-block',
                    fontSize: '11px',
                    color: 'hsla(0,0%,100%,.7)',
                    marginBottom: '4px',
                    verticalAlign: 'middle',
                    fontFamily: "PT Sans, sans-serif",
                    userSelect: 'none'
                }}>Мин. лимит</span>
                <input {...register('limit_min')} type="number" id="limit_min" style={{
                    position: 'relative',
                    borderRadius: '4px',
                    height: '32px',
                    overflow: 'hidden',
                    boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
                    border: 0,
                    background: '#1c2542',
                    color: '#fff',
                    outline: 'none',
                    paddingLeft: 8,
                }} />
            </label>
            <label htmlFor='limit_max' style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: 12,
            }}>
                <span style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    position: 'relative',
                    display: 'inline-block',
                    fontSize: '11px',
                    color: 'hsla(0,0%,100%,.7)',
                    marginBottom: '4px',
                    verticalAlign: 'middle',
                    fontFamily: "PT Sans, sans-serif",
                    userSelect: 'none'
                }}>Макс. лимит</span>
                <input {...register('limit_max')} type="number" id="limit_max" style={{
                    position: 'relative',
                    borderRadius: '4px',
                    height: '32px',
                    overflow: 'hidden',
                    boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
                    border: 0,
                    background: '#1c2542',
                    color: '#fff',
                    outline: 'none',
                    paddingLeft: 8,
                }} />
            </label>
            <div style={{ marginTop: 10, display: 'flex', columnGap: 10 }}>
                {
                    isDirty && (
                        <button type="submit" style={{
                            padding: 10,
                            background: '#ffc324',
                            borderRadius: 4,
                            cursor: 'pointer',
                            color: '#141b33',
                            border: 'none',
                            outline: 'none'
                        }}>
                            Сохранить
                        </button>
                    )
                }

                <button type="button" onClick={handleChangeStatus} style={{
                    padding: 10,
                    background: '#ffc324',
                    borderRadius: 4,
                    cursor: 'pointer',
                    color: '#141b33',
                    border: 'none',
                    outline: 'none',
                    width: '100%'
                }}
                >{status ? 'Отключить' : 'Включить'}</button>
            </div>
        </form>
    )
}

export default PaymentItem;